import { render } from "./CreateFoodOrders-step-2.vue?vue&type=template&id=6aa43089"
import script from "./CreateFoodOrders-step-2.vue?vue&type=script&lang=js"
export * from "./CreateFoodOrders-step-2.vue?vue&type=script&lang=js"

import "./CreateFoodOrders-step-2.vue?vue&type=style&index=0&id=6aa43089&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__